import { useEffect } from "react";

export const SITE_URL = "https://saasradarhub.com";
const INDEX = "index, follow";
const NOINDEX = "noindex, follow";

function headTag(selector, tag, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  return el;
}

export function setCanonical(path) {
  const clean = path === "/" ? "/" : path.replace(/\/+$/, "");
  headTag('link[rel="canonical"]', "link", { rel: "canonical" }).setAttribute("href", SITE_URL + clean);
}

export const articlePath = (a) => `${a.type === "guide" ? "/guides" : "/reviews"}/${a.slug}`;

export function useNoindex(flag) {
  useEffect(() => {
    if (!flag) return undefined;
    const meta = headTag('meta[name="robots"]', "meta", { name: "robots" });
    meta.setAttribute("content", NOINDEX);
    return () => meta.setAttribute("content", INDEX);
  }, [flag]);
}
